import { useRef, useMemo, useState, useEffect, useCallback } from 'react';
import { Button, Drawer, Table } from 'antd';
import DataTable from '../../components/DataTable';
import ButtonConfirm from '../../components/ButtonConfirm';

import request from '@/request';

export default function Finance({ event }) {
  const dataTableRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [orderDetail, setOrderDetail] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [itemsDrawerVisible, setItemsDrawerVisible] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    request.get('/statistics/pay/amount/total/' + event.id).then((res) => {
      setTotalAmount(res || 0);
    });
  });

  const approveRefund = useCallback(async (record) => {
    await request.put(`/user/refund/apply/review/${record.id}`);
    if (dataTableRef.current?.refresh) {
      dataTableRef.current.refresh();
    }
  }, []);

  const tabs = [
    {
      label: '报名订单',
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3 3h2l.4 2M7 13h10l4-8H5.4M16 21a1 1 0 11-2 0 1 1 0 012 0zm-8 0a1 1 0 11-2 0 1 1 0 012 0z"
        />
      ),
      api: '/statistics/pay/list',
      exportAPI: `/statistics/pay/list/export?eventId=${event.id}`,
      columns: [
        {
          title: '订单号',
          dataIndex: 'id',
          key: 'id',
          render: (t) => <span className="truncate block">{t}</span>,
          fixed: 'left',
          ellipsis: true,
        },
        { title: '用户名', dataIndex: 'userName', key: 'userName' },
        { title: '用户ID', dataIndex: 'userId', key: 'userId' },
        { title: '所属机构', dataIndex: 'orgName', key: 'orgName' },
        {
          title: '用户身份',
          dataIndex: 'roleTypeText',
          key: 'roleTypeText',
        },
        { title: '支付方式', dataIndex: 'tradeType', key: 'tradeType' },
        { title: '支付时间', dataIndex: 'payTime', key: 'payTime' },
        {
          title: '支付金额（元）',
          dataIndex: 'totalAmount',
          key: 'totalAmount',
          render: (_, record) => {
            if (record.roleTypeText === '领队') {
              return (
                <Button
                  type="text"
                  onClick={async (e) => {
                    e.stopPropagation();
                    setDrawerVisible(true);
                    const res = await request.get(
                      `/statistics/pay/leader/detail/${record.id}`
                    );
                    setOrderDetail(res);
                  }}
                  style={{ padding: 0, color: '#1890ff' }}
                >
                  {record.totalAmount}
                </Button>
              );
            }
            return record.totalAmount;
          },
        },
        { title: '支付状态', dataIndex: 'statusText', key: 'statusText' },
        { title: '支付失败原因', dataIndex: 'reason', key: 'reason' },
      ],
    },
    {
      label: '退款记录',
      icon: (
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12h6M9 16h6M5 8h14M7 20h10"
        />
      ),
      api: '/statistics/refund/apply/list',
      columns: [
        {
          title: '退款订单',
          dataIndex: 'id',
          key: 'id',
          render: (t) => <span className="truncate block">{t}</span>,
          fixed: 'left',
          ellipsis: true,
        },
        { title: '用户名', dataIndex: 'userName', key: 'userName' },
        { title: '所属机构', dataIndex: 'org', key: 'org' },
        { title: '用户ID', dataIndex: 'userId', key: 'payee' },
        { title: '用户身份', dataIndex: 'userRole', key: 'userRole' },
        {
          title: '退款金额',
          dataIndex: 'refundAmount',
          key: 'refundAmount',
          render: (v, record) => (
            <button
              className="font-xs text-blue-600 hover:text-blue-700 cursor-pointer"
              onClick={() => {
                setSelectedItems(record.items);
                setItemsDrawerVisible(true);
              }}
            >
              {v}
            </button>
          ),
        },
        { title: '发起时间', dataIndex: 'applyTime', key: 'applyTime' },
        { title: '退款时间', dataIndex: 'refundTime', key: 'refundTime' },
        { title: '退款原因', dataIndex: 'reason', key: 'reason' },
        { title: '状态', dataIndex: 'statusText', key: 'statusText' },
        {
          title: '操作',
          key: 'action',
          align: 'right',
          render: (_, record) =>
            record.status === 1 ? (
              <ButtonConfirm
                onConfirm={() => approveRefund(record)}
                description="是否确认退款"
              >
                <span className="font-xs text-blue-600 hover:text-blue-700 cursor-pointer">
                  同意
                </span>
              </ButtonConfirm>
            ) : null,
        },
      ],
    },
    // {
    //   label: '退款记录',
    //   icon: (
    //     <>
    //       <path
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //         d="M7 8h10v8a1 1 0 01-1 1H8a1 1 0 01-1-1V8z"
    //       />
    //       <path
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //         d="M7 8V6a2 2 0 012-2h6a2 2 0 012 2v2"
    //       />
    //       <path
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //         d="M11 13l-2-2m0 0l2-2m-2 2h6"
    //       />
    //     </>
    //   ),
    //   api: '/statistics/refund/list',
    //   columns: [
    //     {
    //       title: '退款订单',
    //       dataIndex: 'id',
    //       key: 'id',
    //       render: (t) => <span className="truncate block">{t}</span>,
    //       fixed: 'left',
    //       ellipsis: true,
    //     },
    //     { title: '支付订单', dataIndex: 'orderId', key: 'orderId' },
    //     { title: '支付人', dataIndex: 'userName', key: 'userName' },
    //     {
    //       title: '退款金额（元）',
    //       dataIndex: 'refundAmount',
    //       key: 'refundAmount',
    //     },
    //     { title: '项目', dataIndex: 'itemName', key: 'itemName' },
    //     { title: '组别', dataIndex: 'groupName', key: 'groupName' },
    //     { title: '退款原因', dataIndex: 'reason', key: 'reason' },
    //     { title: '退款发起时间', dataIndex: 'createdAt', key: 'createdAt' },
    //     { title: '退款完成时间', dataIndex: 'successTime', key: 'successTime' },
    //   ],
    // },
  ];

  const options = useMemo(() => {
    const data = [
      { value: 'userName', label: '用户名' },
      { value: 'orderId', label: '订单号' },
    ];
    if (activeIndex === 0) {
      data.push({
        value: 'status',
        label: '支付状态',
        type: 'select',
        options: [
          { value: '2', label: '已支付' },
          { value: '1', label: '待支付' },
          { value: '3', label: '已取消' },
        ],
      });
    } else {
      data.push({
        value: 'status',
        label: '申请状态',
        type: 'select',
        options: [
          { value: '1', label: '待处理' },
          { value: '2', label: '退款中' },
          { value: '3', label: '已退款' },
          { value: '4', label: '已取消' },
        ],
      });
    }
    return data;
  }, [activeIndex]);

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-3 gap-4">
        {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            className={`flex flex-col items-center justify-center gap-1 py-3 rounded-lg text-center text-sm font-medium transition transform border cursor-pointer ${
              activeIndex === index
                ? 'bg-blue-50 border-blue-200 text-blue-700 shadow-sm'
                : 'bg-white border-slate-200 text-slate-600 hover:shadow hover:-translate-y-0.5'
            }`}
          >
            <div className="flex items-center gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
                aria-hidden="true"
              >
                {tab.icon}
              </svg>
              <span>{tab.label}</span>
            </div>
            {index === 0 && (
              <span className="text-lg text-gray-500">
                总支付金额: ¥{totalAmount.toLocaleString()}
              </span>
            )}
          </button>
        ))}
      </div>

      <DataTable
        ref={dataTableRef}
        options={options}
        columns={tabs[activeIndex].columns}
        api={`${tabs[activeIndex].api}?eventId=${event.id}`}
        exportAPI={tabs[activeIndex].exportAPI}
      />

      <Drawer
        title="订单详情"
        open={drawerVisible}
        onClose={() => setDrawerVisible(false)}
        size={800}
      >
        <Table
          columns={[
            { title: '项目', dataIndex: 'itemName', key: 'itemName' },
            { title: '组别', dataIndex: 'groupName', key: 'groupName' },
            { title: '金额（元）', dataIndex: 'amount', key: 'amount' },
            { title: '选手姓名', dataIndex: 'name', key: 'name' },
            { title: '选手编号', dataIndex: 'id', key: 'id' },
          ]}
          dataSource={orderDetail}
          pagination={false}
          rowKey="id"
        />
      </Drawer>

      <Drawer
        title="项目详情"
        open={itemsDrawerVisible}
        onClose={() => setItemsDrawerVisible(false)}
        size={600}
      >
        <Table
          columns={[
            { title: '项目', dataIndex: 'name', key: 'name' },
            { title: '组别', dataIndex: 'groupName', key: 'groupName' },
            {
              title: '退款金额（元）',
              dataIndex: 'applyPrice',
              key: 'applyPrice',
            },
          ]}
          dataSource={selectedItems}
          pagination={false}
          rowKey={(record) => `${record.itemId}-${record.groupId}`}
        />
      </Drawer>
    </div>
  );
}
